import { Enums } from '../common/enums'

export class OpValidateInfoMessage {

    // Properties

    private _message: string
    public get Message(): string { return this._message }

    private _errorCode: Enums.ValidationErrorCode
    public get ErrorCode(): Enums.ValidationErrorCode { return this._errorCode }

    // Properties End


    // Ctor

    public constructor(opObj: any) {
        if (opObj != null) {
            this._message = opObj.Message
            this._errorCode = opObj.ErrorCode
        }
    }

    // Ctor End
}

export namespace OpValidateInfoMessage {
   
}